import { Controller } from '@hotwired/stimulus';

/**
 * Label color - a board label's swatch popover (board settings): closes once a colour is picked, on Escape or on a
 * click outside it, and keeps the new label's preview chip showing the typed name.
 * Targets: popover (the <details>), name (the name input), preview (the chip; optional)
 * @example <form data-controller="label-color" data-action="click@window->label-color#dismiss keydown.esc->label-color#close">
 */
export default class extends Controller {
  static targets = ['popover', 'name', 'preview'];

  connect () {
    if (this.hasPreviewTarget) this.placeholder = this.previewTarget.textContent;
  }

  picked () {
    this.popoverTarget.open = false;
  }

  dismiss (event) {
    if (!this.popoverTarget.contains(event.target)) this.popoverTarget.open = false;
  }

  close () {
    if (!this.popoverTarget.open) return;

    this.popoverTarget.open = false;
    this.popoverTarget.querySelector('summary').focus();
  }

  rename () {
    if (this.hasPreviewTarget) this.previewTarget.textContent = this.nameTarget.value.trim() || this.placeholder;
  }
}
